import React from 'react';
import JunoClientSnackbar from '../../client/Juno/client/components/global/JunoClientSnackbar';
import TransactionOverview from '../components/TransactionOverview';

export default function TransactionsPage() {
    return (
        <>
            <div className="rounded-[8px] bg-[#F4F4F5] dark:bg-[#18181B] lg:!bg-filterPannel-bg md:border !border-section-br overflow-hidden md:m-1 h-full lg:!mt-[3px]">
                  <TransactionOverview isDashboard={false} />
            </div>
            <JunoClientSnackbar />
        </>
    );
}
